export default __webpack_public_path__ + "static/media/logo-text.c63521e5.svg";